<script lang="ts">
  import { ContactUsForm as FormData } from '@features/contactUs/index';
  import { contactUsForm } from '@features/contactUs/config/store';
  import { onMount } from 'svelte';
  import type { FirstStepContactForm } from '@features/contactUs/config/first-step';
  import type { SecondStepContactForm } from '@features/contactUs/config/second-step';
  import { Container } from '@shared/ui/container';
  import Contacts from './contacts.svelte';

  export let data: { firstStep: FirstStepContactForm; secondStep: SecondStepContactForm };

  onMount(() => {
    contactUsForm.useLocalStorage();
  });
</script>

<Container
  containerClass="xl:pt-25 mx-auto gap-x-10 py-15 pt-16 md:pt-20 lg:gap-x-20 xl:grid xl:grid-cols-2 uw:grid-cols-12 uw:gap-12"
>
  <div class="uw:max-w-full uw:col-span-4 uw:col-start-2 uw:row-start-1 mx-auto mb-12 max-w-[530px] xl:mb-0">
    <Contacts />
  </div>

  <div
    class="xl:col-start-end uw:max-w-full uw:col-span-4 uw:col-start-8 mx-auto max-w-[530px] xl:col-start-2 xl:row-start-1 xl:row-end-3 xl:mb-0 xl:w-full xl:justify-self-start"
  >
    <FormData {data} />
  </div>
</Container>
